import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { WindowComponent } from "sharedFeatures/window";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { Button } from './button.model';
import { DialogPopupBodyComponent } from './dialog-popup-body.component';

@Component({
    selector: 'dialog-popup',
    templateUrl: '../sharedGui/components/window/window.component.html',
    styleUrls: ['../sharedGui/components/window/window.component.less']
})
export class DialogPopupComponent extends WindowComponent {

    buttonArray: Array<Button> = [];
    bodyText: string = '';
    bodyStyle: string = '';
    buttonsTopMargin: number = 0;
    inputParamsTopMargin: number = 10;
    isXeroDisconnect: boolean = false;
    companyName: string = '';
    plansCount: number = 0;

    titleText = $localize`TITLE`;

    private disableButtonsAfterAction: boolean = false;

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {

        super(element, r, viewContainerRef, chDet);

        this.width = -1;
        this.height = -1;

        this.showClose = true;
        this.processEscape = true;

        this.title = this.titleText;
        this.cornerRadius = 10;

        this.isModal = true;

        this.dimOpacity = 0.7;

        this.windowContentBody = DialogPopupBodyComponent;

    }


    getBodyComponent(): DialogPopupBodyComponent {
        return <DialogPopupBodyComponent>super.getBodyComponent();
    }

    public setTitle(title: string) {
        this.title = title;
    }

    public setBody(bodyText: string) {
        this.bodyText = bodyText;
    }

    public setBodyStyle(bodyStyle: string) { 
        this.bodyStyle = bodyStyle;
    }

    public setTestId(value: string) {
        this.testId = value;
    }

    public setButtonArray(buttonArray: Array<Button>) {
        this.buttonArray = buttonArray;
    }

    public setDisableButtonsAfterAction(value: boolean): void {
        this.disableButtonsAfterAction = value;
    }

    public getDisableButtonsAfterAction(): boolean {
        return this.disableButtonsAfterAction;
    }

    public setHeight(height: number) {
        this.height = height;
    }

    public setWidth(width: number) {
        this.width = width;
    }

    public setButtonsTopMargin(height: number) {
        this.buttonsTopMargin = height;
    }

    public setInputParamsTopMargin(value: number) {
        this.inputParamsTopMargin = value;
    }

    public setDeleteButton(b: boolean): void {
        this.showClose = b;
    }

    public setModal() {
        this.isModal = true;
    }

    public setXeroDisconnect(companyName: string, plansCount: number) {
        this.isXeroDisconnect = true;
        this.companyName = companyName;
        this.plansCount = plansCount;
    }

    public async show() {
        return new Promise<void>(resolve => {
            this.afterviewinit.subscribe(() => {

                let x = (DomSmallUtils.width(document.body) - this.getWidth()) / 2;
                let y = (DomSmallUtils.height(document.body) - this.getHeight()) / 2;

                super.show(x, y).then(_ => resolve());

            });
        })


    }

}
